export var ToastType;
(function (ToastType) {
    ToastType["Appointment"] = "appointment";
    ToastType["Client"] = "client";
    ToastType["Pet"] = "pet";
    ToastType["Service"] = "service";
    ToastType["ServiceVariant"] = "service_variant";
    ToastType["User"] = "user";
    ToastType["WorkingHours"] = "working_hours";
    ToastType["TeamMember"] = "team_member";
    ToastType["TeamMemberInvitation"] = "team_member_invitation";
    ToastType["Location"] = "location";
    ToastType["SizeCategory"] = "size_category";
    ToastType["CoatType"] = "coat_type";
    ToastType["SupportTicket"] = "support_ticket";
})(ToastType || (ToastType = {}));
export var Action;
(function (Action) {
    Action["Create"] = "create";
    Action["Update"] = "update";
    Action["Delete"] = "delete";
})(Action || (Action = {}));
